// src/pages/ProjectPage.js
import React from 'react';
import Hero from '../components/Project/Hero';
import Project from '../components/Project/Project';

const ProjectPage = () => {
  return (
    <>
      <Hero />
      <Project />
    </>
  );
};

export default ProjectPage;
